import React from 'react';
import { makeStyles } from '@mui/styles';
import Dropdown, { DropdownProps } from 'components/@common/Inputs/Dropdown';

import { translate } from 'translations/translator';
import { useTheme } from '@mui/material';

const getStatusT = (status: string) => {
  return translate('assignmentTracker', status);
};
type Props = Omit<DropdownProps, 'options'>;

const statusKeys = ['notStarted', 'inProgress', 'completed'];

const AttemptStatusDropdown: React.FC<Props> = props => {
  const theme = useTheme();
  const classes = useStyles(theme)();

  const STATUS_OPTIONS = [
    { value: 'all', label: getStatusT('allOption') },
    ...statusKeys.map(status => ({
      value: status,
      label: getStatusT(status)
    }))
  ];

  return (
    <Dropdown
      displayEmpty
      options={STATUS_OPTIONS}
      classes={{
        select: classes.input,
        root: classes.root
      }}
      {...props}
    />
  );
};

const useStyles = theme =>
  makeStyles(() => ({
    root: () => ({
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(14)
    }),
    input: {
      backgroundColor: 'white !important',
      paddingTop: '3px',
      paddingBottom: '3px',
      width: '240px'
    }
  }));

export default AttemptStatusDropdown;
